import { css } from '@lastbrand/web-ui-styled-system/css'

import type { SystemStyleObject } from '@lastbrand/web-ui-styled-system/types'

// Literal px, not rem: legacy `.applePayIcon` (6rem x 2.4rem) renders ~1.6-2x too tall under the
// DS static-16px root (ds-migration.md fluid-rem footgun). Sized to match the button's title-14 line-height.
export const applePayIconCss = css({
  width: '50px',
  height: '20px',
  flexShrink: 0,
})

// Actual flex-row item — web-ui `Button` has no `className`, only `css`, so caller sizing overrides
// (e.g. add-to-cart-ds) land here instead.
export const applePayWrapperCss = css({
  display: 'flex',
  width: 'full',
  overflow: 'hidden',
  transformOrigin: 'left center',
  transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease-out',
})

// Pre-reveal state (mirrors legacy `.applePayButtonAnimated`). `!important` needed: unlike
// `expressPayRowReadyCss` (product-cta-ds.styles.ts, fixed via mergeLegacyResponsiveStyles), the
// competing `width: 'full'` here isn't a sibling style object we control — it comes from the
// *caller's* separately-compiled `className` (e.g. add-to-cart-ds's `expressPayButtonCss`,
// bundle-product-purchase-ds's `cartButtonWithExpressPayCss`), merged in via `cx()` in
// apple-pay-button-ds.tsx. Since that class is generated by a different css() call, there's no
// single style object to merge it into, so cx()'s non-source-order-safe atomic ordering
// (ai-guidelines/project/ds-migration.md) can't be resolved without `!` short of threading a
// `wrapperCss` override prop through every caller (same shape as this PR's `buttonCss` prop for the
// inner Button) — left as a follow-up if this needs to change again.
export const applePayCollapsedCss = css({
  width: '0!',
  minWidth: '0!',
  transform: 'scaleX(0)',
  opacity: 0,
})

// Revealed state (mirrors legacy `.applePayButtonExpanded`).
export const applePayExpandedCss = css({
  transform: 'scaleX(1)',
  opacity: 1,
})

export const applePayButtonBaseCss: SystemStyleObject = {
  width: 'full',
  height: 'full',
}
